export default {"src":"/assets/_next/static/media/maestro.91aa879e.svg","height":156,"width":200,"blurWidth":0,"blurHeight":0};